import {AccountInfo as IAccountInfo} from '@azure/msal-browser';
import { OrgProfile, UIState } from './actions';
import EventDetail from '../events/interfaces/EventDetail';
import Order, { Stakeholder } from '../pages/types/Order';

export type DUEventInfo = {
    loading?: boolean,
    loaded?: boolean,
    orders: Order[],
    currentOrder?: Order,
    currentEvent?: {
        eventId: string,
        chapterId: string,
        stakeholders: Stakeholder[],
        loading?: boolean,
        loaded?: boolean,
    },
    currentEventDetail?: EventDetail,
};

const eventInfo: DUEventInfo = {
    orders: [],
    currentOrder: undefined,
    currentEvent: {
        eventId: '',
        chapterId: '',
        stakeholders: [],
        loaded: false,
    }
};

const accountInfo: IAccountInfo = {
    homeAccountId: '',
    environment: '',
    tenantId: '',
    username: '',
    name: '',
    localAccountId: '',
};

const orgInfo: OrgProfile = {
    auth_id: undefined,
    constituent_id: undefined,
    needs_change_password: false,
    email_verified: false,
    error: false,
    roles: '',
};

const uiInfo: UIState = {
    drawer_expanded: false,
};

const initialState: InitialStateType = {
    accountInfo,
    orgInfo,
    uiInfo,
    eventInfo,
};

export type InitialStateType = {
    accountInfo: IAccountInfo,
    orgInfo: OrgProfile,
    uiInfo: UIState,
    eventInfo: DUEventInfo
}

export type AccountInfo = IAccountInfo;

export default initialState;